import type { InitData } from '~/composables/useInitData'

export async function useSiteInfo() {
  const initData: Ref<InitData> = await useInitData()
  return initData.value.siteInfo
}
